const IconUnchecked = () => {
  return (
    <svg
      width='21'
      height='22.5'
      viewBox='0 0 21 22.5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.984375'
        y='1.734375'
        width='19.03125'
        height='19.03125'
        rx='4.265625'
        fill='white'
        stroke='#D8E0E5'
        strokeWidth='1.96875'
      />
    </svg>
  );
};

export default IconUnchecked;
